import {h, Fragment} from "preact"
import { closeSearch } from "../../helpers"

export default function SubmitButton({ className, text }) {
    return (
        <button 
            type="submit" 
            className={`ns-autocomplete-submit ${className}`} 
            onClick={closeSearch}
        >
            {text}
        </button>
    )
}